<template>
  <analytics-sub-page
    title="Analytics"
    icon="chart-pie"
    css-class="analytics-homepage"
    default-label="Summary"
    :get-sheet-config="getSheetConfig"
    :section-specs="sectionSpecs"
  >
    <snapshot-metrics ref="snapshotRef" />
    <adoption-metrics ref="adoptionRef" />
    <app-logins-metrics ref="appLoginsRef" />
    <app-features-metrics ref="appFeaturesRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import AdoptionMetrics from '@/pages/analyticsHomepage/components/AdoptionMetrics.vue';
import AppFeaturesMetrics from '@/pages/analyticsHomepage/components/AppFeaturesMetrics.vue';
import AppLoginsMetrics from '@/pages/analyticsHomepage/components/AppLoginsMetrics.vue';
import SnapshotMetrics from '@/pages/analyticsHomepage/components/SnapshotMetrics.vue';

const snapshotRef = ref(null);
const adoptionRef = ref(null);
const appLoginsRef = ref(null);
const appFeaturesRef = ref(null);

const getSheetConfig = () => snapshotRef.value?.getPdfData?.() || {};

const sectionSpecs = [
  { key: 'adoption', label: 'Adoption', ref: adoptionRef },
  { key: 'app-logins', label: 'App engagement', ref: appLoginsRef },
  { key: 'app-features', label: 'App features', ref: appFeaturesRef },
];
</script>
